import { render, staticRenderFns } from "./vehicletype.vue?vue&type=template&id=1241e81d&scoped=true&"
import script from "./vehicletype.vue?vue&type=script&lang=js&"
export * from "./vehicletype.vue?vue&type=script&lang=js&"
import style0 from "./vehicletype.vue?vue&type=style&index=0&id=1241e81d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1241e81d",
  null
  
)

export default component.exports